{
    "title": "Start here",
    "subtitle": "What this platform is, and what someone in your role should look at first. Every figure below is a count of records actually loaded, and every step opens a working screen.",

    "tour": {
        "yours": "Your tour",
        "for": "Written for {{roles}}",
        "minutes": "About {{count}} minutes",
        "open": "Open",
        "step": "Step {{number}}",
        "others": "Tours for other roles",
        "switch": "Show this tour"
    },

    "pillars": {
        "title": "One customer, four pillars",
        "help": "The complaint, the call, the branch visit and the survey response are the same person. Nothing below is a separate system with its own copy of the customer.",
        "spine": "Customer master",
        "spine_help": "One record per person, whichever identifier you arrive with.",
        "complaints": "Complaints",
        "complaints_help": "Intake, routing, SLA and closure, on the Omani working calendar.",
        "contact_centre": "Contact centre",
        "contact_centre_help": "Calls, chat, email and social in one console.",
        "queue": "Branch queue",
        "queue_help": "Kiosk, counter and hall display, with an honest wait estimate.",
        "measurement": "Experience measurement",
        "measurement_help": "NPS, CSAT and CES, with Arabic analysed as Arabic.",

        "record_customers": "customers",
        "record_timeline_entries": "timeline entries",
        "record_complaints": "complaints",
        "record_categories": "categories",
        "record_conversations": "conversations",
        "record_agents": "agents",
        "record_tickets": "tickets",
        "record_branches": "branches",
        "record_responses": "responses",
        "record_surveys": "surveys"
    },

    "compliance": {
        "title": "Requirement coverage",
        "help": "Derived from annotations in the source, not maintained by hand. Open the matrix to see the code and tests behind each requirement.",
        "mandatory": "Mandatory",
        "essential": "Essential",
        "desirable": "Desirable",
        "of": "{{implemented}} of {{total}}",
        "open": "Open the matrix"
    },

    "scenarios": {
        "title": "Prepared scenarios",
        "help": "Short demonstrations that each answer one question, on the control panel.",
        "open": "Open the control panel"
    }
}
